import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './CompaniesSubTab.css';

const API_URL = process.env.REACT_APP_API_URL || '';

function CompaniesSubTab() {
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [editingCompany, setEditingCompany] = useState(null);
  const [formData, setFormData] = useState({ name: '', description: '', vacancies_url: '' });

  useEffect(() => {
    fetchCompanies();
  }, []);

  const fetchCompanies = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}/api/companies`);
      setCompanies(response.data);
      setError(null);
    } catch (err) {
      setError('Ошибка при загрузке компаний: ' + (err.response?.data?.detail || err.message));
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingCompany) {
        await axios.put(`${API_URL}/api/companies/${editingCompany.id}`, formData);
      } else {
        await axios.post(`${API_URL}/api/companies`, formData);
      }
      setShowForm(false);
      setEditingCompany(null);
      setFormData({ name: '', description: '', vacancies_url: '' });
      fetchCompanies();
    } catch (err) {
      setError('Ошибка при сохранении компании: ' + (err.response?.data?.detail || err.message));
    }
  };

  const handleEdit = (company) => {
    setEditingCompany(company);
    setFormData({
      name: company.name,
      description: company.description || '',
      vacancies_url: company.vacancies_url || ''
    });
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Вы уверены, что хотите удалить эту компанию? Все связанные mock-собеседования также будут удалены.')) {
      try {
        await axios.delete(`${API_URL}/api/companies/${id}`);
        fetchCompanies();
      } catch (err) {
        setError('Ошибка при удалении компании: ' + (err.response?.data?.detail || err.message));
      }
    }
  };

  const handleCancel = () => {
    setShowForm(false);
    setEditingCompany(null);
    setFormData({ name: '', description: '', vacancies_url: '' });
  };

  if (loading) {
    return <div className="loading">Загрузка...</div>;
  }

  return (
    <div className="companies-sub-tab">
      <div className="tab-header">
        <h3>Управление компаниями</h3>
        {!showForm && (
          <button className="btn btn-primary" onClick={() => setShowForm(true)}>
            + Добавить компанию
          </button>
        )}
      </div>

      {error && <div className="error-message">{error}</div>}

      {showForm && (
        <div className="form-container">
          <h4>{editingCompany ? 'Редактировать компанию' : 'Добавить новую компанию'}</h4>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Название компании *</label>
              <input
                type="text"
                id="name"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                required
                maxLength={255}
                placeholder="Введите название компании"
              />
            </div>
            <div className="form-group">
              <label htmlFor="description">Описание</label>
              <textarea
                id="description"
                value={formData.description}
                onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                rows={4}
                placeholder="Введите описание компании"
              />
            </div>
            <div className="form-group">
              <label htmlFor="vacancies_url">Ссылка на сайт с вакансиями</label>
              <input
                type="url"
                id="vacancies_url"
                value={formData.vacancies_url}
                onChange={(e) => setFormData({ ...formData, vacancies_url: e.target.value })}
                maxLength={500}
                placeholder="https://example.com/careers"
              />
            </div>
            <div className="form-actions">
              <button type="submit" className="btn btn-primary">
                {editingCompany ? 'Сохранить' : 'Создать'}
              </button>
              <button type="button" className="btn btn-secondary" onClick={handleCancel}>
                Отмена
              </button>
            </div>
          </form>
        </div>
      )}

      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Название</th>
              <th>Описание</th>
              <th>Ссылка на вакансии</th>
              <th>Действия</th>
            </tr>
          </thead>
          <tbody>
            {companies.length === 0 ? (
              <tr>
                <td colSpan="5" className="empty-state">
                  Нет компаний. Добавьте первую компанию.
                </td>
              </tr>
            ) : (
              companies.map((company) => (
                <tr key={company.id}>
                  <td>{company.id}</td>
                  <td>{company.name}</td>
                  <td>{company.description || '-'}</td>
                  <td>
                    {company.vacancies_url ? (
                      <a href={company.vacancies_url} target="_blank" rel="noopener noreferrer">
                        {company.vacancies_url}
                      </a>
                    ) : (
                      '-'
                    )}
                  </td>
                  <td>
                    <button
                      className="btn-icon btn-edit"
                      onClick={() => handleEdit(company)}
                      title="Редактировать"
                    >
                      ✏️
                    </button>
                    <button
                      className="btn-icon btn-delete"
                      onClick={() => handleDelete(company.id)}
                      title="Удалить"
                    >
                      ✕
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default CompaniesSubTab;

